import { styled, StyleProps } from "../styles"
import { flexCss } from "../Flex"

export const MailIconContainer = styled.div((props: StyleProps) => ({
  ...flexCss,
  justifyContent: `center`,
  alignItems: `center`,
  width: `50px`,
  height: `50px`,
  borderRadius: `50%`,
  backgroundColor: props.theme.palette.grey.light,
  color: props.theme.palette.coal.dark,
}))
